<template>
  <el-table-column
    prop="nav_id"
    sortable="custom"
    label="NAV azonosító"
    show-overflow-tooltip
    min-width="180"
  >
    <template slot-scope="scope">
      {{ scope.row.nav_id }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'nav_id',
};
</script>
